/**
 * @description Returns `true` if `value` is empty, else `false`.
 * @param {*} value
 * @returns {Boolean}
 */
export default (value) => {
  if (!value) return true;
  return Object.keys(value).length === 0;
};
